<template>
    <div class="page-thanks">
        <div class="thanks-box box-max-w clearfix">
            <p class="pc-view ">謝謝你的參與！請查閱短訊及優惠連結</p>
            <div class="mobile-view bold">
                <span class="participate">謝謝你的參與！</span>
                <span class="check">請查閱短訊及優惠連結</span>
            </div>
            <p>
                你將會收到確認信息。按下短訊內的連結進入優惠券頁面，請於指定商戶收銀處使用，每次交易只可使用此優惠一次。
                <span>閣下必須於{{deadline}}兌換，逾期無效</span> ，並不能重覆使用。
            </p>
            <p>
                如在 <u>5分鐘</u> 內仍然未收到短訊，請按重新發送短訊。
            </p>
            <form class="sms-form" 
                @submit.prevent="resendSMS"
                v-if="!showResend"
            >
                <div class="resend-link-box">
                    <button type="submit" class="btn tc resend"
                        :class="{'btn-loading': is_loading || !stop_count}"
                    >
                        重新發送短訊<span class="timer"> {{time}}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import smsService from '../service/smsService';

export default {
    name: "thanks",
    props:{
        count:{
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            is_loading: false,
            stop_count: false,
            time: '(4:59)',
            loopTimes: 0
        }
    },
    computed: {
        showResend(){
            return this.loopTimes == Math.abs( this.count.availableTimes * 1 )
        },
        deadline() {
            let str = '';
            this.count.ttl ? str = `${this.count.ttl}分鐘內` : str = '優惠期前';
            return str;
        }
    },
    methods: {
        formatTime(min, sec){
            return `(${min}:${sec >= 10 ? sec : "0" + sec })`
        },
        runCountDown(){
            this.time = '(4:59)'
            let duration = moment.duration(5, 'minutes').subtract(1, 'seconds')
            let countDown = setInterval(() => {
                duration.subtract(1, 'seconds')
                this.time = this.formatTime(
                    duration.minutes(),
                    duration.seconds()
                )
                if( duration.asSeconds() <= 0 ){
                    this.time = ''
                    clearInterval(countDown)
                    this.stop_count = true
                }
            }, 1000)
        },
        resendSMS(){
            if(this.is_loading) return;
            if(!this.stop_count) return;
            this.is_loading = true;
            this.stop_count = false;

            smsService.send({
                phone: this.count.phone,
                id: this.count.id
            })
            .then(resp => {
                if(resp.status){
                    this.runCountDown()
                    this.loopTimes ++
                }else{
                    alert(resp.error.msg)
                    this.stop_count = true
                }
            })
            .catch(() => {
                this.stop_count = true;
            })
            .finally(() => {
                this.is_loading = false;
            })
        },
    },
    mounted(){
        this.runCountDown()
    }
}
</script>